import * as React from 'react';
import {
	CheckboxGroup as CheckboxGroupCore,
	ICheckboxGroupProps as ICheckboxGroupPropsCore
} from '../core/checkbox-group';

import styles from './checkbox-group.module.scss';
import checkboxStyles from '../checkbox/checkbox.module.scss';

export interface ICheckboxGroupProps extends ICheckboxGroupPropsCore {}

const CheckboxGroup = (props: ICheckboxGroupProps): React.JSX.Element => {
	return <CheckboxGroupCore {...props} propStyles={styles} checkboxStyles={checkboxStyles} />;
};

export { CheckboxGroup };
